export const FLORMAR_HEADER_HEIGHT = 70;

export const PluginTypes = {
  MAKEUP: 'Makeup',
  NAIL: 'Nail',
};

// This will be filled with plugin states
// so that some custom icons will be shown by listening the plugin.
export let currentPluginState = {
  pluginStep: null,
  pluginType: PluginTypes.MAKEUP,
  pluginSelector: '#makeupView',
  hasFaceRecognitionError: false,
  // Make sure the plugin is loaded before clicking the product again.
  isPluginAvailable: false,
  isInitialLoad: false,
};

let carouselImageLoadCount = 0;

/**
 * Default Flormar template customizations on init.
 * It also sets a part of currentPluginState to inform that plugin is loaded.
 * @param {string} pluginSelector - Element selector of Makeup or Nailpolish plugins.
 */
export const initPluginConfig = () => {
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      changeBackgroundColor: { color: '#D0D1D2' },
    }),
    '*',
  );
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      changeTryLabel: { label: 'DENEMEYE BAŞLA!' },
    }),
    '*',
  );
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      changeTakePhotoButtonColorAndLabel: {
        label: 'Fotoğraf Çek',
        color: 'white',
      },
    }),
    '*',
  );
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      functionchangeTakePhotoWithAppButtonColorAndLabel: {
        label: 'Fotoğraf Çek',
        color: 'white',
        iconExists: true,
      },
    }),
    '*',
  );
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      changeChoosModelColorAndLabel: {
        label: 'Model Seç',
        color: 'white',
      },
    }),
    '*',
  );
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ disableButtonsHoverActions: '' }), '*');
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ changeLabelsFonts: '' }), '*');
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ useFlormarModels: '' }), '*');
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ hideKvkkModal: '' }), '*');
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ hideCheckboxLabel: '' }), '*');
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      changeApplyPhotoButtonColorAndLabel: {
        label: 'Hemen Dene',
        color: '#FF3EB5',
      },
    }),
    '*',
  );
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      changeTakeAnotherLabel: { label: 'Tekrar Dene' },
    }),
    '*',
  );
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      changeChooseModelText: { text: 'Model Seç' },
    }),
    '*',
  );
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ showBeforeAfterLabels: '' }), '*');
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      hidePluginButtons: true,
    }),
    '*',
  );
  currentPluginState.isPluginAvailable = true;
  currentPluginState.isInitialLoad = true;
  if ($(window).width() > helpers.Breakpoints.WIDE_TABLET) {
    $('.loader').removeClass('active');
    return;
  }
  hideMobileLoader('.mobile .category-image');
};

/**
 * Plugin has gray background color initally to show it is disabled.
 * Update its color here after a product is selected.
 */
export const updatePluginOnProductSelection = () => {
  document.querySelector(currentPluginState.pluginSelector).classList.remove('disabled');
  document
    .querySelector(currentPluginState.pluginSelector)
    .contentWindow.window.postMessage(
      JSON.stringify({ changeBackgroundColor: { color: '#FF3EB5' } }),
      '*',
    );
  document.querySelector(currentPluginState.pluginSelector).contentWindow.window.postMessage(
    JSON.stringify({
      changeTakePhotoButtonColorAndLabel: {
        label: 'Fotoğraf Çek',
        color: 'white',
      },
    }),
    '*',
  );
  document.querySelector(currentPluginState.pluginSelector).contentWindow.window.postMessage(
    JSON.stringify({
      changeChoosModelColorAndLabel: {
        label: 'Model Seç',
        color: 'white',
      },
    }),
    '*',
  );
};

/**
 * We use custom icons for Flormar template, hide the defaults.
 */
export const hidePluginIconsOnModelSelections = () => {
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ hideBackButton: '' }), '*');
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ hideSlider: '' }), '*');
};

/**
 * We hide onboardingBackgroundImage, because its blocks makeup divs.
 */
export const hideOnboardingBackgroundImage = () => {
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(
      JSON.stringify({ toggleOnboardingBackgroundImage: false }),
      '*',
    );
};

/**
 * Hide loader, when category images are loaded.
 * @param {string} categorySelector - Element selector of mobile category image.
 */
export const hideMobileLoader = (categorySelector) => {
  $(categorySelector).each(function () {
    if (this.complete) {
      const checkFontInterval = setInterval(() => {
        if (document.fonts.status == 'loaded') {
          $('.loader').removeClass('active');
          $('.selections-wrapper').removeClass('scroll-preventive');
          $('.loader .fas').addClass('passive');
          // When we hide without timeout, transition is not work.
          setTimeout(() => {
            $('.loader').addClass('passive');
          }, 1000);
          clearInterval(checkFontInterval);
          return;
        }
      }, 100);
    }
    $(this).on('load', function () {
      if (!this.complete) return;
      // Image loaded, increase the count.
      carouselImageLoadCount++;
      if (
        carouselImageLoadCount == document.querySelectorAll(categorySelector).length &&
        document.fonts.status == 'loaded'
      ) {
        $('.loader').removeClass('active');
        $('.selections-wrapper').removeClass('scroll-preventive');
        $('.loader .fas').addClass('passive');
        // When we hide without timeout, transition is not work.
        setTimeout(() => {
          $('.loader').addClass('passive');
        }, 1000);
      }
    });
  });
};
